import { reactive } from 'vue'

export const config = reactive({
    siteName: 'Boostaminophen',
    logo: '/img/logo-c.png',
    language: 'en-US',
    developmentMode: false
})
